module.exports = __webpack_public_path__ + "img/finland-neoplasm-female.298e9ffd.png";